<template>

  <v-container fluid class="main-navigation-shipper">

    <!-- Home page -->
    <router-link :to="{ name: 'home' }">
      <v-btn plain class="primary-nav-element" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-home</v-icon> Home
      </v-btn>
    </router-link>

    <!-- Track Order -->
    <router-link :to="{ name: 'track-order' }">
      <v-btn plain class="primary-nav-element mt-4" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-target</v-icon> Track Order
      </v-btn>
    </router-link>

    <!-- Submit Orders (admin, dispatcher) -->
    <router-link :to="{ name: 'provider-order-list' }" v-if="hasRole('admin') || hasRole('dispatcher')">
      <v-btn plain class="primary-nav-element mt-4" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-arrow-top-right-thin-circle-outline</v-icon> Submit Orders
      </v-btn>
    </router-link>

    <!-- Deliveries (admin, driver) -->
    <router-link :to="{ name: 'delivery-list-dispatched' }" v-if="hasRole('admin') || hasRole('driver')">
      <v-btn plain class="primary-nav-element mt-3" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-truck-delivery</v-icon> {{ navLabelForDeliveries }}
      </v-btn>
    </router-link>

    <!-- Receiver Locations -->
    <router-link :to="{ name: 'receiver-list' }">
      <v-btn plain class="primary-nav-element mt-3" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-store</v-icon> Receiver Locations
      </v-btn>
    </router-link>

    <!-- Manage inventory pages (admin, dispatcher) -->
    <v-expansion-panels flat accordion class="mt-4" v-model="manageInventoryNavSetting" v-if="showInventoryNav && (hasRole('admin') || hasRole('dispatcher'))">
      <v-expansion-panel>
        <v-expansion-panel-header>Inventory</v-expansion-panel-header>
        <v-expansion-panel-content>
          <router-link v-for="navItem in manageInventoryNavPages" :key="navItem.page" :to="{ name: navItem.page }">
            <v-btn plain class="secondary-nav-element mt-2" @click="emitClickEvent">
              <v-icon small class="mr-2" v-if="navItem.icon">{{ navItem.icon }}</v-icon>
              {{ navItem.label }}
            </v-btn>
          </router-link>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Manage data pages (admin, dispatcher) -->
    <v-expansion-panels flat accordion :class="(showInventoryNav) ? 'mt-1' : 'mt-4'" v-model="manageDataNavSetting" v-if="hasRole('admin') || hasRole('dispatcher')">
      <v-expansion-panel>
        <v-expansion-panel-header>Manage Orders</v-expansion-panel-header>
        <v-expansion-panel-content>
          <router-link v-for="navItem in manageDataNavPages" :key="navItem.page" :to="{ name: navItem.page }">
            <v-btn plain class="secondary-nav-element mt-2" @click="emitClickEvent">
              <v-icon small class="mr-2" v-if="navItem.icon">{{ navItem.icon }}</v-icon>
              {{ navItem.label }}
            </v-btn>
          </router-link>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Manage org pages (admin) -->
    <v-expansion-panels flat accordion class="mt-1" v-model="manageOrgNavSetting" v-if="hasRole('admin')">
      <v-expansion-panel>
        <v-expansion-panel-header>Manage Org</v-expansion-panel-header>
        <v-expansion-panel-content>
          <router-link v-for="navItem in manageOrgNavPages" :key="navItem.page" :to="{ name: navItem.page }">
            <v-btn plain class="secondary-nav-element mt-2" @click="emitClickEvent">
              <v-icon small class="mr-2" v-if="navItem.icon">{{ navItem.icon }}</v-icon>
              {{ navItem.label }}
            </v-btn>
          </router-link>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Org profile -->
    <router-link :to="{ name: 'org-profile' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-account-circle-outline</v-icon> Org Profile
      </v-btn>
    </router-link>

    <!-- Org members -->
    <router-link :to="{ name: 'user-list' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-account-multiple</v-icon> Org Members
      </v-btn>
    </router-link>

    <!-- User settings -->
    <router-link :to="{ name: 'user-settings-profile' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-cog</v-icon> User Settings
      </v-btn>
    </router-link>

    <!-- Logout -->
    <div>
      <v-btn plain class="primary-nav-element mt-5" @click="$root.logout">
        <v-icon small class="mr-2">mdi-logout</v-icon> Logout
      </v-btn>
    </div>

    <div class="spacer" />

    <!-- Terms of Use -->
    <v-row align="end">
      <v-col align="center">
        <router-link :to="{ name: 'terms-of-use' }">
          <v-btn color="primary" plain class="primary-nav-element" @click="emitClickEvent">
            Terms of Use
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
export default {
  name: 'MainNavigationShipperUi',

  data () {
    return {
      showInventoryNav: false,
      manageInventoryNavSetting: 0,
      manageDataNavSetting: 0,
      manageOrgNavSetting: 0
    }
  },

  computed: {
    activeUser () {
      return this.$store.getters['auth/activeUser']
    },
    activeUserRoles () {
      return this.activeUser.roles
    },
    navLabelForDeliveries () {
      return (this.hasRole('admin')) ? 'Deliveries' : 'My Deliveries'
    },
    // Manage inventory pages
    manageInventoryNavPages () {
      return [
        { label: 'Products', page: 'order-list-placed', icon: 'mdi-package-variant-closed' },
        { label: 'Brands', page: 'credit-list-issued', icon: 'mdi-watermark' }
      ]
    },
    // Manage data pages
    manageDataNavPages () {
      return [
        { label: 'Orders', page: 'order-list-placed', icon: 'mdi-package-variant-closed' },
        { label: 'Credits', page: 'credit-list-issued', icon: 'mdi-credit-card' },
        { label: 'Routes', page: 'route-list-created', icon: 'mdi-directions-fork' }
      ]
    },
    // Manage org pages
    manageOrgNavPages () {
      return [
        { label: 'Shipper Accounts', page: 'provider-connection-list', icon: 'mdi-link' },
        { label: 'Vehicles', page: 'vehicle-list', icon: 'mdi-car' },
        { label: 'Vehicle Lot', page: 'vehicle-lot-item', icon: 'mdi-parking' }
      ]
    }
  },

  methods: {
    hasRole (role) {
      return this.$root.utils.includes(this.activeUserRoles, role)
    },

    emitClickEvent () {
      this.$emit('navClicked')
    }
  }
}
</script>

<style>
  .main-navigation-shipper {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .main-navigation-shipper .primary-nav-element {
    padding-left: 8px !important;
  }

  .main-navigation-shipper .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: #0e0e0e;
  }

  .main-navigation-shipper .v-expansion-panel-header {
    padding-left: 8px !important;
    color: #727272;
    font-size: 0.8rem;
    font-weight: 500;
    letter-spacing: 1.6px;
    text-transform: uppercase !important;
  }

  .main-navigation-shipper .v-expansion-panel-header {
    padding-right: 0;
  }

  .main-navigation-shipper .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: unset;
    padding-right: 0;
  }

  .main-navigation-shipper .v-expansion-panel-content__wrap {
    padding-left: 0px;
  }

  .spacer {
    flex-grow: 1;
  }
</style>
